var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"create-sell-offer-view"},[(_vm.message)?_c('MessageModal',{attrs:{"message":_vm.message,"error":false}}):_vm._e(),(_vm.project)?_c('CreateSellOfferForm',{staticClass:"create-sell-offer-view__form",attrs:{"asset":_vm.project}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }